/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {VehicleEngineeringMode} from '@ion/core/src/types/entities';

const {
  ONLINE,
  OFFLINE,
  VALIDATION,
  DISABLED,
  PROVISIONING,
  OPT_OUT
} = VehicleEngineeringMode;

/**
 * Maps each `VehicleEngineeringMode` value to its translation key under the
 * `vehicle-manager:engineeringMode` locale namespace.
 */
export const VEHICLE_ENGINEERING_MODE_LABEL_KEYS: Record<VehicleEngineeringMode, string> = {
  [ONLINE]       : 'online',
  [OFFLINE]      : 'offline',
  [VALIDATION]   : 'validation',
  [DISABLED]     : 'disabled',
  [PROVISIONING] : 'provisioning',
  [OPT_OUT]      : 'opt_out'
};

/**
 * Resolves the translated label for a vehicle engineering mode.
 *
 * ```typescript
 * import {getVehicleEngineeringModeLabel} from
 *   '@ion/applications/src/pages/vehicle/VehicleEngineeringModeUtils';
 * ...
 *
 * const label = getVehicleEngineeringModeLabel(translations, VehicleEngineeringMode.ONLINE);
 * ```
 *
 * @param   translations The `vehicle-manager:engineeringMode` translation map.
 * @param   modeValue The engineering mode to translate.
 * @returns The translated label, or `undefined` when the mode has no label.
 */
export const getVehicleEngineeringModeLabel = (
  translations: Record<string, string>,
  modeValue?: VehicleEngineeringMode
): string | undefined => {
  const key = modeValue !== undefined ? VEHICLE_ENGINEERING_MODE_LABEL_KEYS[modeValue] : undefined;
  return key ? translations[key] : undefined;
};
